<forge-card *ngIf="showCard">
    <form attr.slot="header" *ngIf="initialized" [formGroup]="userLookupForm" fxLayout="row">
        <forge-toolbar>
            <h2 slot="start" class="forge-typography--heading4">User Lookup</h2>
        </forge-toolbar>
        <lgd-typeahead controlName="user" label (searchTextChanged)="lookupUser($event)" [options]="userLookupObservable">
        </lgd-typeahead>
    </form>
    <busy-indicator *ngIf="loading"></busy-indicator>
    <info-card *ngIf="selectedUserId && !loading" [itemId]="selectedUserId" cardProviderId="UserLookup.InfoCardProvider">
    </info-card>
    <info-card *ngIf="selectedUserId && !loading" class="no-padding" [itemId]="selectedUserId" cardProviderId="UserEquipment.InfoCardProvider" [expand]="true">
    </info-card>
</forge-card>